import React from 'react';
import { Button } from './../../../../themes/button';
import { MoreVertIcon } from './../../../../themes/icons';
import { Paper, Popper, ClickAwayListener, Grow } from './../../../../themes/default';
import { MenuItem, MenuList } from './../../../../themes/input';
import { withStyles } from './../../../../themes/default';

const styles = theme => ({
  popper: { boxShadow: theme.shadows[1], zIndex: 9 }
});

class Dropdown extends React.Component {

  state = {
    open: false
  };

  handleToggle = () => {
    this.setState(state => ({ open: !state.open }));
  };

  handleClose = event => {
    if (this.anchorEl.contains(event.target)) {
      return;
    }

    this.setState({ open: false });
  };

  render() {

    const { classes } = this.props;
    const { open } = this.state;

    return (
      <div>
        <Button
          size={ this.props.size ? this.props.size : 'small' }
          variant={ this.props.variant ? this.props.variant : 'text' }
          color={ this.props.color ? this.props.color : 'default' }
          buttonRef={node => {
                        this.anchorEl = node;
                      }}
                      aria-owns={open ? 'menu-list-grow' : null}
                      aria-haspopup="true"
                      onClick={this.handleToggle}
        >
          { this.props.children ? (
            this.props.children
          ) : (
            <MoreVertIcon fontSize="small"/>
          )}
        </Button>
        <Popper className={ classes.popper } open={open} anchorEl={this.anchorEl} transition disablePortal>
          {({ TransitionProps, placement }) => (
            <Grow
              {...TransitionProps}
              style={{ transformOrigin: placement === 'bottom' ? 'center top' : 'center bottom' }}
            >
              <Paper>
                <ClickAwayListener onClickAway={this.handleClose}>
                  <MenuList>
                    { this.props.items.length > 0 && (
                      this.props.items.map(item => {
                        return(
                          <MenuItem key={ item.label } onClick={ item.event } dense>{ item.label }</MenuItem>
                        )
                      })
                    )}
                  </MenuList>
                </ClickAwayListener>
              </Paper>
            </Grow>
          )}
        </Popper>
      </div>
    );
  }
}

export default withStyles(styles)(Dropdown);
